import { useSelector } from 'react-redux';

import type { Sorting } from '@/ui/flux/fiat-balances/selectors/create-sorted-assets-selector-factory';
import createSortedAssetsSelectorFactory from '@/ui/flux/fiat-balances/selectors/create-sorted-assets-selector-factory';
import createSupportedBuyAssetsSelector from '@/ui/flux/fiat-ramp/selectors/create-supported-buy-assets';

const SORTING = [
  ['fiatBalance', 'desc'],
  ['displayName', 'asc'],
] satisfies Sorting;

function useSupportedBuyCryptoAssets(providerName: string) {
  return useSelector(
    createSortedAssetsSelectorFactory(
      createSupportedBuyAssetsSelector(providerName),
    )(SORTING),
  );
}

export default useSupportedBuyCryptoAssets;
